import authReducer from './reducer';

export {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  LOGOUT,
  authRequest,
  authSuccess,
  authFailure,
  loginRequest,
  loginSuccess,
  loginFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
  logout
} from './actions';

export {
  isAuthenticating,
  isAuthenticated,
  getUser,
  getUserCustomers,
  getActiveCustomer,
  hasMultipleCustomers,
  getUserUpdatePaymentMethodToken,
  getUserActivePaymentMethod
} from './selectors';

export default authReducer;



// WEBPACK FOOTER //
// ./src/store/auth/index.js